
const breakpoints = {
    names: ["base", "xs", "sm", "md", "lg", "xl", "xxl"],
    nums:  [0,      480,  768,  1024, 1280, 1536, 1920]
}

/**
 * Renvoie le breakpoint courant
 * @returns {string}
 */
export function getBreakpoint() {
    for (let i = 0, l = breakpoints.nums.length, lastIndex = breakpoints.nums.length - 1; i < l; i++) {
        if (i < lastIndex) {
            if (window.innerWidth >= breakpoints.nums[i] && window.innerWidth < breakpoints.nums[i + 1])
                return breakpoints.names[i];
        } else return breakpoints.names[lastIndex];
    }
}

/**
 * Indique si checkpoint est atteint (strictement ou non) à checkpoint
 * !!!! Ne vérifie pas validité de breakpointName !!!!
 * @param {string} breakpointName : ex : md, xl, ....
 * @param {boolean} strict (opt) :
 * - Si false (default): vérifie si largeur d'écran supérieur ou égale à checkpoint
 * - Si true : vérifie si largeur d'écran strictement supérieur à checkpoint
 * @returns {boolean}
 */
export function breakpointBiggerThan(breakpointName, strict=false) {
    strict = typeof strict !== "boolean" ? false : strict;
    let index = breakpoints.names.indexOf(breakpointName);
    return strict === true
        ? window.innerWidth > breakpoints.nums[index]
        : window.innerWidth >= breakpoints.nums[index];
}

/**
 * Renvoie l'aspect ratio de la fenêtre
 * @returns {number}
 */
export function getAspectRatio() {
    return window.innerWidth / window.innerHeight;
}

/**
 * Indique si l'aspect ratio de la fenêtre est supérieur à number
 * @param {number} number 
 * @param {boolean} strict supérieur strinctement ?
 * @returns {boolean}
 */
export function aspectRatioBiggerThan(number, strict=false) {
    strict = typeof strict !== "boolean" ? false : strict;
    const aspectRatio = window.innerWidth / window.innerHeight;
    return strict === true ? aspectRatio > number : aspectRatio >= number;
}
